import { Components, Theme } from '@mui/material/styles';

export const buttonThemeDefinition = () =>
  ({
    MuiButton: {
      defaultProps: {
        disableFocusRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  } as Components<Theme>);
